import React from 'react'
import { compose } from 'recompose'
import { withAuthorization, AuthUserContext } from '../Session'
import { withFirebase } from '../Firebase'
import PlansPage from '../Payment/PlansPage'

import { useTranslation } from 'react-i18next'

const AccountPaymentBase = props => {
  const { t } = useTranslation()

  return (
    <AuthUserContext.Consumer>
      {authUser => (
        <div className='accountBox'>  
          <div className='accountContent'>
            <h1 className='sectionTitle'>{t('Köp abonnemang')}</h1>
            <p>&nbsp;</p>
            <PlansPage authUser={authUser} />
          </div>
        </div>
      )}
    </AuthUserContext.Consumer>
  )
}

const AccountPage = withFirebase(AccountPaymentBase)

const condition = authUser => !!authUser

export default compose(
  // withEmailVerification,
  withAuthorization(condition)
)(AccountPage)
